import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { getMetaByTokenId } from "../services/metaService";
import { toast } from "react-toastify";
import { toInteger } from 'lodash';
import {
    auctionContractAddress,
    ListingType, marketplaceContractAddress, web3,
} from "../utils/blockchainInteractor";
import { Modal, Spinner } from "reactstrap";
import ListForm from "./listForm";
import UserContext from "../contexts/UserContext";
import { getTokenInfo } from "../utils/commonInteractor";
import { buyToken, unListTokenMarketplace } from "../utils/marketPlaceInteractor";
import useLoader from "../hooks/useLoader";
import { approveSpenderERC20, getSymbolERC20 } from '../utils/erc20Interactor';
import AuctionForm from './auctionForm';
import { claimToken, getAuctionInfo, index, refund, claimNFT, isAuctionOpen, bid } from '../utils/auctionInteractor';
import moment from 'moment';

function NftDetail({ match }) {
    const { state } = useContext(UserContext);
    const [loader, showLoader, hideLoader] = useLoader();
    const history = useHistory();
    const [nftDetails, setNftDetails] = useState(null);
    const [tokenId, setTokenId] = useState(match.params.id);
    const [openListModal, setOpenListModal] = useState(false);
    const [openAuctionModal, setOpenAuctionModal] = useState(false);
    const [openChoiceModal, setOpenChoiceModal] = useState(false);
    const [ERCSYMBOL, setERCSYMBOL] = useState('');
    const [bidPrice, setBidPrice] = useState();
    const [timer, setTimer] = useState(null);
    const timerFun = () => {
        nftDetails?.listingType === ListingType.AUCTION && setTimer(getTimeRemaining());
    }
    useEffect(() => {
        init();
    }, [])

    useEffect(()=>{
        setInterval(timerFun, 500);
    },[nftDetails])


    const getTimeObj = (totalSeconds) => {
        let secondsRemaining = totalSeconds;
        const days = Math.floor(secondsRemaining / (60 * 60 * 24));
        secondsRemaining = secondsRemaining - days * 24 * 60 * 60;
        const hours = Math.floor(secondsRemaining / (60 * 60));
        secondsRemaining = secondsRemaining - hours * 60 * 60;
        const minutes = Math.floor(secondsRemaining / (60));
        secondsRemaining = secondsRemaining - minutes * 60;
        const seconds = Math.floor(secondsRemaining);
        return { days, hours, minutes, seconds, totalSeconds };
    }
    const getTimeRemaining = () => {
        const today = moment();
        const endDate = moment(toInteger(nftDetails?.endAuction) * 1000);
        const duration = moment.duration(endDate.diff(today));
        let secondsRemaining = duration.asSeconds();
        return getTimeObj(secondsRemaining);
    }

    const init = async () => {
        if (match && match.params && match.params.id) {
            match.params.id && await fetchNFT(tokenId);
        } else {
            toast.error('NFT not Found!');
            history.replace('/');
        }
        setERCSYMBOL((await getSymbolERC20()));
    }

    const fetchNFT = async id => {
        try {

            showLoader('Loading item....')
            const { data: nft } = await getMetaByTokenId(id);
            let res = await getTokenInfo(id);
            if (res.listingType === ListingType.AUCTION) {
                const latestIndex = await index();
                for (let i = 0; i < latestIndex; i++) {
                    const auction = await getAuctionInfo(i);
                    if (auction.nftId === id) {
                        const { addressNFTCollection, addressPaymentToken, bidCount, creator, currentBidOwner, currentBidPrice, endAuction, index } = auction;
                        const isOpen = await isAuctionOpen(index);
                        res = { ...res, isOpen, addressNFTCollection, addressPaymentToken, bidCount, creator, currentBidOwner, currentBidPrice, endAuction, index };

                    }
                }
            }
            await setNftDetails({ ...nft, ...res });
        } catch (e) {
            toast.error('Something went wrong!');
            history.replace('/');
        } finally {
            hideLoader();
        }
    };

    const listItem = async () => {
        setOpenListModal(true);
    }

    const auctionItem = async () => {
        setOpenAuctionModal(true);
    }



    const unListItem = async () => {
        try {
            showLoader('Unlisting....')
            const res = await unListTokenMarketplace(tokenId);
        } catch (e) {
            toast.error('Something went wrong!');
        } finally {
            hideLoader();
            fetchNFT(tokenId);
        }
    }


    const handleBuy = async () => {
        try {
            showLoader('Buying....')
            await approveSpenderERC20(marketplaceContractAddress, nftDetails?.price);
            const res = await buyToken(tokenId);
        } catch (e) {
            toast.error('Something went wrong!');
            console.log(e);
        } finally {
            hideLoader();
            fetchNFT(tokenId);
        }
    }

    const bidItem = async () => {
        try {
            showLoader('Bidding ....')

            await approveSpenderERC20(auctionContractAddress, web3.utils.toWei(bidPrice.toString()));
            const res = await bid(nftDetails?.index, web3.utils.toWei(bidPrice.toString()));
        } catch (e) {
            toast.error('Something went wrong!');
        } finally {
            hideLoader();
            fetchNFT(tokenId);
        }
    }
    const claimTokens = async () => {
        try {
            showLoader('Claiming Tokens....')
            const res = await claimToken(nftDetails?.index);
        } catch (e) {
            toast.error('Something went wrong!');
        } finally {
            hideLoader();
            fetchNFT(tokenId);
        }
    }
    const claimNFTs = async () => {
        try {
            showLoader('Claiming NFT....')
            const res = await claimNFT(nftDetails?.index);
        } catch (e) {
            toast.error('Something went wrong!');
        } finally {
            hideLoader();
            fetchNFT(tokenId);
        }
    }

    const refundAuction = async () => {
        try {
            showLoader('Refunding....')
            const res = await refund(nftDetails?.index);
        } catch (e) {
            toast.error('Something went wrong!');
        } finally {
            hideLoader();
            fetchNFT(tokenId);
        }
    }

    const getMaskAddress = (address) => {
        if (address) {
            return address.substring(0, 4) + '...' + address.slice(-4);
        }
        return '';
    }

    return (
        <>
            {
                loader
            }
            {nftDetails &&
                <div className="item-pages-wrp">
                    <div className="container">

                        <div className="fox-heading text-center">
                            <h4>Item Page</h4>
                        </div>
                        <div className="item-tp-rw">
                            <div className="itm-pgt-lft">
                                <div className="item-pgt-prevImg"><img src={nftDetails?.image || '/assets/img/item-page-prev.png'} alt="" /></div>
                                <div className="powerby-logo">
                                    <div className="pwdb-content">
                                        <span>Powered by</span>
                                        <p></p>
                                    </div>
                                    <img src="/assets/img/logo.jpg" alt="" />
                                </div>
                            </div>
                            <div className="itm-pgt-rit">
                                <div className="itm-pgt-heding">
                                    <div className="itm-pgt-hadL">
                                        <h3>{nftDetails?.name}</h3>
                                    </div>
                                </div>
                                <div className="itm-pgt-desc">
                                    <h6>Description</h6>
                                    <p>
                                        {nftDetails?.description}
                                    </p>
                                </div>


                                <ul className="itm-admin-owner">
                                    {
                                        nftDetails?.listingType === ListingType.AUCTION && <li>
                                            <div className="itm-owner-pic">
                                                <img src="/assets/img/customer1.png" alt="" />
                                            </div>
                                            <div className="itm-owner-cont">
                                                <p>Creator</p>
                                                <h6>{getMaskAddress(nftDetails?.creator)}</h6>
                                            </div>
                                        </li>
                                    }
                                    <li>
                                        <div className="itm-owner-pic">
                                            <img src="/assets/img/customer1.png" alt="" />
                                        </div>
                                        <div className="itm-owner-cont">
                                            <p>Owner</p>
                                            <h6>{getMaskAddress(nftDetails?.owner)}</h6>
                                        </div>
                                    </li>

                                </ul>
                                {
                                    nftDetails?.price && <div className="bid-collection-wrp">
                                        <div className="bid-coll-item">
                                            <span>Price:</span>
                                            <h6>{nftDetails?.price && web3.utils.fromWei(nftDetails?.price)} {ERCSYMBOL}</h6>
                                        </div>
                                    </div>
                                }

                                {
                                    ListingType[nftDetails?.listingType] === ListingType.AUCTION && <>
                                        <div className="bid-collection-wrp">
                                            {
                                                Number(nftDetails?.bidCount) > 0 && <div className="bid-coll-item">
                                                    <span>Bid Owner:</span>
                                                    <h6>{nftDetails?.currentBidOwner && `${getMaskAddress(nftDetails?.currentBidOwner)}`}</h6>
                                                </div>
                                            }
                                            <div className="bid-coll-item">
                                                <span>Current bid:</span>
                                                <h6>{nftDetails?.currentBidPrice && `${web3.utils.fromWei(nftDetails?.currentBidPrice)} ${ERCSYMBOL}`}</h6>
                                            </div>
                                            {
                                                timer?.totalSeconds > 0 ? <div className="d-flex justify-content-around">
                                                    <div className="d-flex flex-column mr-2 bid-coll-item">
                                                        <h6 className="hour">{timer?.days || '00'}</h6>
                                                        <span>Days</span>
                                                    </div>
                                                    <div className="d-flex flex-column mr-2 bid-coll-item">
                                                        <h6 className="hour">{timer?.hours || '00'}</h6>
                                                        <span>Hours</span>
                                                    </div>
                                                    <div className="d-flex flex-column mr-2 bid-coll-item">
                                                        <h6 className="minutes">{timer?.minutes || '00'}</h6>
                                                        <span>Mins</span>
                                                    </div>
                                                    <div className="d-flex flex-column mr-2 bid-coll-item">
                                                        <h6 className="seconds">{timer?.seconds || '00'}</h6>
                                                        <span>Sec</span>
                                                    </div>
                                                </div> : <div className="bid-coll-item">
                                                    <span>Timer</span>
                                                    <h6>Time up!!</h6>
                                                </div>
                                            }

                                        </div>
                                    </>
                                }
                                {
                                    nftDetails?.owner.toLowerCase() === state?.user?.address.toLowerCase() && ListingType[nftDetails?.listingType] === ListingType.NOT_LISTED &&
                                    <button onClick={() => setOpenChoiceModal(true)} className="btns place-bid-btn">List Item</button>}
                                {
                                    nftDetails?.owner.toLowerCase() !== state?.user?.address.toLowerCase() && ListingType[nftDetails?.listingType] === ListingType.MARKETPLACE &&
                                    <button onClick={handleBuy} className="btns place-bid-btn">Buy Now <img src="/assets/img/icon/shopping-bag.png" alt="" /></button>}

                                {
                                    nftDetails?.owner.toLowerCase() === state?.user?.address.toLowerCase() && ListingType[nftDetails?.listingType] === ListingType.MARKETPLACE &&
                                    <button onClick={unListItem} className="btns place-bid-btn">Delist Item</button>}
                                {
                                    !nftDetails?.isOpen && nftDetails?.currentBidOwner?.toLowerCase() === state?.user?.address?.toLowerCase() && ListingType[nftDetails?.listingType] === ListingType.AUCTION &&
                                    <button onClick={claimNFTs} className="btns place-bid-btn">Claim NFT</button>}
                                {
                                    !nftDetails?.isOpen && nftDetails?.creator?.toLowerCase() === state?.user?.address?.toLowerCase() && ListingType[nftDetails?.listingType] === ListingType.AUCTION &&
                                    <button onClick={claimTokens} className="btns place-bid-btn">Claim Tokens</button>}
                                {
                                    nftDetails?.isOpen && nftDetails?.creator?.toLowerCase() !== state?.user?.address?.toLowerCase() && nftDetails?.currentBidOwner?.toLowerCase() !== state?.user?.address?.toLowerCase() && ListingType[nftDetails?.listingType] === ListingType.AUCTION && timer?.totalSeconds > 0 &&
                                    <div className='d-flex align-items-center'>
                                        <div className="form-group acc-form mt-2 mb-0">
                                            <label>Bid Price ({ERCSYMBOL})</label>
                                            <input className="form-control" type="number" name="bidPrice" value={bidPrice}
                                                onChange={({ currentTarget }) => setBidPrice(currentTarget.value)} />
                                        </div>
                                        <button onClick={bidItem} disabled={Number(web3.utils.toWei(bidPrice || '0')) <= Number(nftDetails?.currentBidPrice)} className="btns place-bid-btn ml-4 align-self-end">Place Bid</button> </div>}
                                {
                                    nftDetails?.creator?.toLowerCase() === state?.user?.address?.toLowerCase() && ListingType[nftDetails?.listingType] === ListingType.AUCTION && Number(nftDetails?.bidCount) < 1 &&
                                    <button onClick={refundAuction} className="btns place-bid-btn">Refund</button>}
                            </div>
                        </div>
                    </div>
                </div>
            }
            <Modal centered contentClassName={"no-border"} isOpen={openListModal} toggle={() => setOpenListModal(!openListModal)} backdrop={true}
                keyboard={false}>
                <div className="account-box">
                    <a href="/" className="account-logo"><img style={{ width: '100%' }} src="/assets/img/logo.jpg" alt="" /></a>
                    <ListForm showLoader={showLoader} hideLoader={hideLoader} reset={() => { fetchNFT(tokenId); setOpenListModal(false) }} tokenId={tokenId} />

                </div>
            </Modal>
            <Modal centered contentClassName={"no-border"} isOpen={openAuctionModal} toggle={() => setOpenAuctionModal(!openAuctionModal)} backdrop={true}
                keyboard={false}>
                <div className="account-box">
                    <a href="/" className="account-logo"><img style={{ width: '100%' }} src="/assets/img/logo.jpg" alt="" /></a>
                    <AuctionForm showLoader={showLoader} hideLoader={hideLoader} reset={() => { fetchNFT(tokenId); setOpenAuctionModal(false) }} tokenId={tokenId} />
                </div>
            </Modal>

            <Modal centered contentClassName={"no-border"} isOpen={openChoiceModal} toggle={() => setOpenChoiceModal(!openChoiceModal)} backdrop={true}
                keyboard={false}>
                <div className="account-box">
                    <a href="/" className="account-logo"><img style={{ width: '100%' }} src="/assets/img/logo.jpg" alt="" /></a>
                    <div className='d-flex justify-content-between'>
                        <div onClick={() => { listItem(); setOpenChoiceModal(false) }} className='choice-item'><img src="/assets/img/icon/money-bag.svg" /><p className='pb-0'>Fixed Price</p></div>
                        <div onClick={() => { auctionItem(); setOpenChoiceModal(false) }} className='choice-item'><img src="/assets/img/icon/hammer.svg" /><p className='pb-0'>Auction</p></div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default NftDetail;
